import React from 'react';
import { Link } from 'react-router-dom';
import { Truck, ShieldCheck, CreditCard, Package } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0f0f0f] text-gray-300" data-id="element-93">
      {/* Trust strip */}
      <div className="border-b border-white/10" data-id="element-94">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-95">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-96">
            {[{
            icon: Truck,
            title: 'Nationwide Shipping',
            desc: 'Orders ship across the U.S.'
          }, {
            icon: ShieldCheck,
            title: 'Secure Online Checkout',
            desc: 'Encrypted checkout flow'
          }, {
            icon: Package,
            title: 'Systems, Bundles & Modules',
            desc: 'Full Yarbo Y Series catalog'
          }, {
            icon: CreditCard,
            title: 'In Stock & Ready to Ship',
            desc: 'Available now'
          }].map(({
            icon: Icon,
            title,
            desc
          }) => <div key={title} className="flex items-start gap-3" data-id="element-97">
                <Icon className="w-6 h-6 text-yarbo-yellow flex-shrink-0 mt-0.5" data-id="element-98" />
                <div data-id="element-99">
                  <div className="font-bold text-sm text-white" data-id="element-100">{title}</div>
                  <div className="text-xs text-gray-400 mt-0.5" data-id="element-101">{desc}</div>
                </div>
              </div>)}
          </div>
        </div>
      </div>

      {/* Main */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-id="element-102">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10 mb-10" data-id="element-103">
          {/* Brand */}
          <div className="col-span-2 md:col-span-3 lg:col-span-1" data-id="element-104">
            <Link to="/" className="flex flex-col mb-4" data-id="element-105">
              <span className="text-2xl font-extrabold tracking-tight text-white leading-none" data-id="element-106">
                Merem Robotics
              </span>
              <span className="text-xs font-medium text-gray-400 tracking-wide mt-1" data-id="element-107">
                Yarbo robotic yard-care systems
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-gray-400 mb-4" data-id="element-108">
              Merem Robotics sells Yarbo robotic yard-care systems, modules,
              bundles, and accessories online.
            </p>
            <p className="text-xs text-gray-500" data-id="element-109">
              Michigan-based. Shipping nationwide.
            </p>
          </div>

          {/* Shop */}
          <div data-id="element-110">
            <h4 className="text-sm font-bold uppercase tracking-wider mb-5 text-white" data-id="element-111">
              Shop
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-112">
              <li data-id="element-113">
                <Link to="/shop" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-114">
                  Shop All Products
                </Link>
              </li>
              <li data-id="element-115">
                <Link to="/category/complete-systems" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-116">
                  Complete Systems
                </Link>
              </li>
              <li data-id="element-117">
                <Link to="/category/lawn-mowers" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-118">
                  Robot Lawn Mowers
                </Link>
              </li>
              <li data-id="element-119">
                <Link to="/category/snow-blowers" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-120">
                  Robotic Snow Blowers
                </Link>
              </li>
              <li data-id="element-121">
                <Link to="/category/leaf-blowers" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-122">
                  Leaf Blowers
                </Link>
              </li>
              <li data-id="element-123">
                <Link to="/category/bundles" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-124">
                  Bundles
                </Link>
              </li>
              <li data-id="element-125">
                <Link to="/category/modules" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-126">
                  Modules
                </Link>
              </li>
              <li data-id="element-127">
                <Link to="/category/accessories" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-128">
                  Accessories
                </Link>
              </li>
            </ul>
          </div>

          {/* Shop by Task */}
          <div data-id="element-129">
            <h4 className="text-sm font-bold uppercase tracking-wider mb-5 text-white" data-id="element-130">
              Shop by Task
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-131">
              <li data-id="element-132">
                <Link to="/category/lawn-care" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-133">
                  Lawn Care
                </Link>
              </li>
              <li data-id="element-134">
                <Link to="/category/snow-removal" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-135">
                  Snow Removal
                </Link>
              </li>
              <li data-id="element-136">
                <Link to="/category/leaf-cleanup" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-137">
                  Leaf Cleanup
                </Link>
              </li>
              <li data-id="element-138">
                <Link to="/category/trimming-edging" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-139">
                  Trimming &amp; Edging
                </Link>
              </li>
              <li data-id="element-140">
                <Link to="/category/tow-transport" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-141">
                  Tow &amp; Transport
                </Link>
              </li>
            </ul>
          </div>

          {/* Help */}
          <div data-id="element-142">
            <h4 className="text-sm font-bold uppercase tracking-wider mb-5 text-white" data-id="element-143">
              Help
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-144">
              <li data-id="element-145">
                <Link to="/compare" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-146">
                  Compare Systems
                </Link>
              </li>
              <li data-id="element-147">
                <Link to="/faq" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-148">
                  FAQ
                </Link>
              </li>
              <li data-id="element-149">
                <Link to="/contact" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-150">
                  Contact
                </Link>
              </li>
              <li data-id="element-151">
                <Link to="/contact" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-152">
                  Shipping &amp; Returns
                </Link>
              </li>
              <li data-id="element-153">
                <Link to="/contact" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-154">
                  Order Support
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-155">
            <h4 className="text-sm font-bold uppercase tracking-wider mb-5 text-white" data-id="element-156">
              Company
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-157">
              <li data-id="element-158">
                <Link to="/contact" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-159">
                  About Merem Robotics
                </Link>
              </li>
              <li data-id="element-160">
                <Link to="/contact" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-161">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-162">
          <p className="text-xs text-gray-500" data-id="element-163">
            &copy; {new Date().getFullYear()} Merem Robotics. All rights
            reserved.
          </p>
          <p className="text-xs text-gray-500 max-w-3xl text-left md:text-right" data-id="element-164">
            Yarbo product names, images, and trademarks belong to their
            respective owner. Merem Robotics is a retailer of Yarbo robotic
            yard-care products.
          </p>
        </div>
      </div>
    </footer>;
}